export enum DeviceCategory {
  DESKTOP,
  TABLET_MOBILE,
}
